'use strict';

var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventCategories = require('./eventCategories');
var eventNames = require('./eventNames');

module.exports = (_module$exports = {}, _defineProperty(_module$exports, eventCategories.PORTAL, [eventNames.DELETE_PORTAL]), _defineProperty(_module$exports, eventCategories.TENANT, [eventNames.ASSIGN_TENANT_TO_PORTAL, eventNames.UNASSIGN_TENANT_TO_PORTAL]), _module$exports);